import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Heading, HeadingPriority } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useTranslation } from 'react-i18next';
const BoxedTitle = ({ heading, queryValue, headingOne, headingSize, leadingSpaceNeeded, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    return (_jsx(Box, { desktop: { spacing: { paddingBottom: 2, paddingLeft: leadingSpaceNeeded ? 4 : 0 } }, tablet: { spacing: { paddingLeft: leadingSpaceNeeded ? 3 : 0 } }, mobile: { spacing: { paddingRight: 2, paddingLeft: leadingSpaceNeeded ? 2 : 0 } }, children: _jsxs(Heading, { priority: headingOne ? HeadingPriority.H1 : HeadingPriority.H2, type: headingSize, children: [`${heading} `, t('boxed-title.search-term'), ` ${queryValue}`] }) }));
};
export default BoxedTitle;
